/**
 * Constants for the file upload component
 * @module constants
 */

/**
 * Maximum file size in bytes (10MB)
 * @constant {number}
 */
export const MAX_FILE_SIZE = 52428800;

/**
 * Document type options for file classification
 * @constant {Object[]}
 * @property {string} value - The value used internally for the document type
 * @property {string} label - The display label for the document type
 */
export const DOCUMENT_TYPE_OPTIONS = [
  { value: "Drivers License", label: "Drivers License" },
  { value: "Voided Check", label: "Voided Check" },
  { value: "Bank Statements", label: "Bank Statements" },
  { value: "Processing Statements", label: "Processing Statements" },
  { value: "Financials", label: "Financials" },
  { value: "Misc. Business Information", label: "Misc. Business Information" },
  { value: "Reserve", label: "Reserve" },
  { value: "Inside Photo", label: "Inside Photo" },
  { value: "Outside Photo", label: "Outside Photo" },
  { value: "Marketing Material", label: "Marketing Material" },
  { value: "Rate Review", label: "Rate Review" },
  { value: "Menu for MaxxPay", label: "Menu for MaxxPay" },
  { value: "WHO pre-questionnaire", label: "WHO pre-questionnaire" },
  { value: "Misc.", label: "Misc." },
];

/**
 * File type options as string values (legacy format)
 * @constant {string[]}
 */
export const FILE_TYPE_OPTIONS = DOCUMENT_TYPE_OPTIONS.map(
  (option) => option.label,
);

/**
 * Accepted file types for the dropzone component
 * @constant {string}
 */
export const ACCEPTED_FILE_TYPES =
  ".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pages";

/**
 * Supported file formats display text
 * @constant {string}
 */
export const SUPPORTED_FORMATS_TEXT =
  "jpg, jpeg, png, doc, docx, xlsx, xls, ppt, pptx, pages, keynote, numbers, pdf";
